import { render } from "./ProductDetailView.vue?vue&type=template&id=62a41717&scoped=true"
import script from "./ProductDetailView.vue?vue&type=script&lang=js"
export * from "./ProductDetailView.vue?vue&type=script&lang=js"

import "./ProductDetailView.vue?vue&type=style&index=0&id=62a41717&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-62a41717"]])

export default __exports__